import React from 'react';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import { map } from 'lodash';

import * as videoOps from '../../../api/Videos/video-operations';
import { VIDEO_TYPES } from '../../../api/Videos/Videos';

const VideoSourceField = ({ updatedVideo, toggleButtonSwitch, handleSourceVideo }) => {
  return (
    <Form.Group>
      <Form.Label>Video Source</Form.Label>
      <Form.Control
        as="select"
        name="type"
        defaultValue={videoOps.getType(updatedVideo)}
        onFocus={() => toggleButtonSwitch()}
        onChange={event => handleSourceVideo(event.target.value)}
      >
        {map(VIDEO_TYPES.properties, ({ value, humanValue }) => (
          <option value={value} key={value}>
            {humanValue}
          </option>
        ))}
      </Form.Control>
    </Form.Group>
  );
};
VideoSourceField.defaultProps = {
  handleSourceVideo: () => {}
};
VideoSourceField.propTypes = {
  updatedVideo: PropTypes.object.isRequired,
  toggleButtonSwitch: PropTypes.func.isRequired,
  handleSourceVideo: PropTypes.func
};

export default VideoSourceField;
